import { render, staticRenderFns } from "./MedicalIdentityForm.vue?vue&type=template&id=3ab923be&"
import script from "./MedicalIdentityForm.vue?vue&type=script&lang=js&"
export * from "./MedicalIdentityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports